import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query/react';

import { useGetGeoZoneIconQuery } from '../../../../../entities/logistic/logisticTasks/redux/logisticTasks.api';
import Image from './styles/Image';

const POLL_INTERVAL = 300_000; // 5 минут

export default function FieldIcon({ geozoneId }) {
  const params = useParams();
  const logisticTaskId = parseInt(params.logisticTaskId, 10);

  const [iconUrl, setIconUrl] = useState(null);

  const shouldSkip = !geozoneId || !logisticTaskId;

  const { data: geoZoneImageBlob } = useGetGeoZoneIconQuery(shouldSkip ? skipToken : { logisticTaskId, geozoneId }, {
    pollingInterval: POLL_INTERVAL,
  });

  useEffect(() => {
    if (!geoZoneImageBlob) return undefined;

    const newUrl = URL.createObjectURL(geoZoneImageBlob);
    setIconUrl(newUrl);

    return () => {
      URL.revokeObjectURL(newUrl);
    };
  }, [geoZoneImageBlob]);

  const devicePixelRatio = window.devicePixelRatio || 1;

  return iconUrl && <Image src={iconUrl} alt="Икона поля" devicePixelRatio={devicePixelRatio} />;
}

FieldIcon.propTypes = {
  geozoneId: PropTypes.oneOfType([PropTypes.number]).isRequired,
};
